import React from "react";
import {executeQuery} from "../../requests/executeQuery";
import {formatName, percent} from "../../utils";
import order from './order';
import {STRIVE_AGENT_PIPELINE_DETAILS,HOTLIST_PROPERTIES_BY_EMAIL,HOTLIST_PROPERTIES} from '../../consts/queries';
import {getData} from "../../requests/CRUD";
import PipelineDetails from "../PipelineDetails/PipelineDetails";
import {hotlist,proposal, active, negotiation, underContract, closed, closedYTD, closedHistorical} from "../PipelineDetails/PipelineDetails";
import {TEAM} from "../../consts/tables";
import moment from "moment";
import {getCurrentAccess} from "../../access";
import {isOwnSummitPipelineOnly} from "../../access-levels";

/** The agent to show: the one asked for, or the signed-in agent when they may see only their own pipeline. */
const scopeAgentId = (id, userData) =>
    isOwnSummitPipelineOnly(getCurrentAccess()) && userData && userData.id ? String(userData.id) : id;

export default class AgentPipelineDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [hotlist]: {
                    name: 'Hot List',
                    data: [],
                    total: {},
                },
                [proposal]: {
                    name: 'Proposals',
                    data: [],
                    total: {},
                },
                [active]: {
                    name: 'Active Listings',
                    data: [],
                    total: {},
                },
                [negotiation]: {
                    name: 'Neg/Under Contract',
                    data: [],
                    total: {},
                },
                [closedYTD]: {
                    name: 'Closed - YTD',
                    data: [],
                    total: {},
                },
                [closedHistorical]: {
                    name: 'Closed - Historical',
                    data: [],
                    total: {},
                },
            },
            agentName: '',
            loading: true,
            componentName: 'agentPipelineDetails',
            currentUserEmail: ''
        };
    }

    static createOptionsWithOnlyEmailId({emailId}) {
        return {
            param: {
                EMAIL_ID : emailId
            },        
        };
    }
    static createOptions({id, status1, status2, isYtd = 0, orderBy}) {
        return {
            param: {
                AGENT_ID: id,
                STATUS_1: status1,
                STATUS_2: status2 ? status2 : 'NOMATCH',
                IS_YTD: isYtd
            },
            order: order(orderBy),
        };
    }

    /**
     * The fee columns are the agent's share of the deal's SUMMIT Fee - Auto and Total Closing Fee - Auto,
     * as the query works them out. A closed table is shown newest first, but its Gross Cumulative still
     * runs oldest to newest, so each row is the total through that closing.
     */
    static buildFeeShareTable(status, table, data, id, newestFirst = false) {
        const rows = newestFirst ? [...data].reverse() : data;
        const built = AgentPipelineDetails.buildTable(status, table, rows, "", id);
        const withShares = built.data.map((row, index) => ({
            ...row,
            PERCENTAGE: percent(rows[index].AGENT_SUMMIT_FEE_PERCENT || 0, 2),
            TOTAL_PERCENTAGE: percent(rows[index].AGENT_TOTAL_FEE_PERCENT || 0, 2),
        }));
        return {...built, data: newestFirst ? withShares.reverse() : withShares};
    }

    buildTables(res) {
        const tables = {...this.state.tables};
        // The agent slots on a property are strings, and the pipeline list links here with a numeric id.
        const id = String(scopeAgentId(this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id), this.props.userData));
        tables[hotlist] = AgentPipelineDetails.buildTable(hotlist,  tables[hotlist], res[5].data, "", id);
        tables[proposal] = AgentPipelineDetails.buildTable(proposal, tables[proposal], res[0].data, "", id);
        tables[active] = AgentPipelineDetails.buildTable(active, tables[active], res[1].data), "", id;
        tables[negotiation] = AgentPipelineDetails.buildFeeShareTable(negotiation, tables[negotiation], res[2].data, id);
        tables[closedYTD] = AgentPipelineDetails.buildFeeShareTable(closedYTD, tables[closedYTD], res[3].data, id, true);
        tables[closedHistorical] = AgentPipelineDetails.buildFeeShareTable(closedHistorical, tables[closedHistorical], res[4].data, id, true);
        this.setState({tables});
    }

    fetch(id,emailId) {   
        if(id && typeof(id) !== 'string'){
            id = id.toString();
        }     
        const hotListOptions = AgentPipelineDetails.createOptionsWithOnlyEmailId({
            emailId: emailId
        });
        const proposalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: proposal,
            orderBy: 'DATE_CREATED.asc'
        });
        const activeOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: active,
            orderBy: 'LISTING_DATE.asc'
        });
        const negotiationOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: negotiation,
            status2: underContract,
            orderBy: 'STATUS.asc'
        });
        const closedYtdOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            isYtd: 1,
            orderBy: 'CLOSE_OF_ESCROW.desc'
        });
        const closedHistoricalOptions = AgentPipelineDetails.createOptions({
            id: id,
            status1: closed,
            orderBy: 'CLOSE_OF_ESCROW.desc'
        });

        const requests = [           
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: proposalOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: activeOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: negotiationOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedYtdOptions}),
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedHistoricalOptions}),
            executeQuery({queryName: HOTLIST_PROPERTIES_BY_EMAIL, options: hotListOptions}),
        ];
        let agentPhone = '';
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        let hotlistAgent;
        const options = {
            column: [
                'ON_PHONES',
                'FIRST_NAME',
                'LAST_NAME',
                'EMAIL'
            ],
            filter: [{
                'text': id,
                'code': 'ARCIMEDES_ROW_ID',
                'type': 'exact',
            }],
        };
        requests.push(getData({tableCode: TEAM, options}));
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            requests.push(getData({tableCode: TEAM, options}));
        }
        Promise.all(requests).then(async (res) => {       
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data) &&
                res[4] && res[4].success && Array.isArray(res[4].data) &&
                res[5] && res[5].success && Array.isArray(res[5].data) &&
                res[6] && res[6].success && Array.isArray(res[6].data) &&
                (!res[7] || res[7] && res[7].success && Array.isArray(res[7].data)))
                {
                if (res[7]) {
                    agentName = formatName(res[7].data[0]);
                }
                if (res[6]) {
                    agentPhone = res[6].data[0].ON_PHONES;
                    this.setState({currentUserEmail: res[6].data[0].EMAIL})
                    res[5].data = await this.hotlistProperties({EMAIL_ID: res[6].data[0].EMAIL});   
                    if (agentPhone) {
                        this.calculateDateRange(agentPhone);
                    }
                }
                res[3].data = res[3].data.filter(property => property.TRANSACTION_TYPE !== "Extra Payment");
                res[4].data = res[4].data.filter(property => property.TRANSACTION_TYPE !== "Extra Payment");
                this.setState({agentName}, () => this.buildTables(res));
            }
            this.setState({loading: false});
        });
    }
    hotlistProperties(hotlistAgent) {        
        const hotListOptions = AgentPipelineDetails.createOptionsWithOnlyEmailId({
            emailId: hotlistAgent.EMAIL_ID
        });
        const requests = [
            executeQuery({queryName: HOTLIST_PROPERTIES, options: hotListOptions}),
        ];
    
        return Promise.all(requests).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data)) {
                return res[0].data;  
            }
            return [];  
        }).catch(error => {
            console.error("Error fetching hotlist properties:", error);
            return [];  
        });
    }   

    calculateDateRange(date) {
        const givenDate = moment(date, 'YYYY-MM-DD');
        const today = moment();
        const diffInYrs = today.diff(givenDate, 'years', true);
        if (diffInYrs <= 1.5) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =3
            this.state.tables[negotiation].goalValue = 2
            this.state.tables[closedYTD].goalValue = 4
        } else if (diffInYrs > 1.5 && diffInYrs <= 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =6
            this.state.tables[negotiation].goalValue = 4
            this.state.tables[closedYTD].goalValue = 8
        } else if (diffInYrs > 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[active].goalValue =10
            this.state.tables[negotiation].goalValue = 5
            this.state.tables[closedYTD].goalValue = 12
        }
        this.setState({tables: {...this.state.tables}});
    }

    componentDidMount() {
        const id = scopeAgentId(this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id), this.props.userData);
        const emailId = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.userData.email :
            (this.props.id ? this.props.id : this.props.userData.email);
        if (id) {
            this.fetch(id,emailId);
            return;
        }
        this.setState({loading: false});
    }
}